export class BaseDTO {

}
